module.exports = __webpack_public_path__ + "img/foot_logo.3cf7b474.png";